import type {
  MenuGroupTitleOption,
  MenuOption,
} from '@spaced-out/ui-design-system/lib/components/Menu';
import type {AtsClientEntity} from 'src/types/ats-entities';
import startCase from 'lodash/startCase';


export const getBrandDisplayName = (
  brandName: string | null | undefined,
  isPrimary: boolean,
): string => {
  if (brandName) {
    return isPrimary ? `${brandName} (Default)` : brandName;
  }
  return 'Unknown Brand';
};

export const getGroupedEntityOptions = (
  entities: Array<AtsClientEntity>,
  customerBusinessType: string,
): Array<MenuGroupTitleOption> => {
  const entityOptions: Array<MenuOption> = [];
  const leadEntityOptions: Array<MenuOption> = [];

  entities.forEach(({name, display_name, is_lead_entity}) => {
    if (
      // check whether to show the entity in the dropdown
      !(
        name === 'ae_client_company_employee' &&
        customerBusinessType === 'corporate'
      )
    ) {
      const entity = {
        key: name,
        label: startCase(display_name),
      } as const;
      if (!is_lead_entity) {
        entityOptions.push(entity);
      } else {
        leadEntityOptions.push(entity);
      }
    }
  });

  return [
    {
      groupTitle: 'LEADS',
      options: leadEntityOptions,
    },
    {
      groupTitle: 'ATS FIELDS',
      options: entityOptions,
    },
  ];
};

export async function convertImageToSquare(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const size = Math.max(img.width, img.height);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (!ctx) {
          return reject('Canvas not supported');
        }

        canvas.width = size;
        canvas.height = size;

        // Fill with white background
        ctx.fillStyle = '#FFFFFF';
        ctx.fillRect(0, 0, size, size);

        // Draw image centered
        const x = (size - img.width) / 2;
        const y = (size - img.height) / 2;
        ctx.drawImage(img, x, y);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject('Image processing failed');
            }
            const newFile = new File([blob], file.name, {type: 'image/jpeg'});
            resolve(newFile);
          },
          'image/jpeg',
          1,
        );
      };
      img.onerror = () => reject('Invalid image');
      img.src = e.target?.result as string;
    };
    reader.onerror = () => reject('File reading error');
    reader.readAsDataURL(file);
  });
}
